import React from 'react'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiSpacer
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="DDXWICprHwA"
                    title="IN-9008 FHD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-9008 FHD Objektivjustage"
              footer={
                <EuiText>
                  <p>Objektiv scharfstellen IN-9008 Full HD.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="Nad_WSK2PCE"
                    title="IN-8015 FHD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-8015 FHD Objektivjustage"
              footer={
                <EuiText>
                  <p>Objektiv scharfstellen IN-8015 Full HD.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>

        <EuiSpacer />
        
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="dOYGMS6R838"
                    title="IN-7011 HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-7011 HD Objektivjustage"
              footer={
                <EuiText>
                  <p>In diesem Video erklären wir Ihnen wie Sie bei Ihrer Überwachungskamera IN-7011HD manuell das Objektiv scharfstellen können sofern Sie einen Bereich überwachen möchten der sich sehr nahe bzw. sehr weit weg von der Kamera befindet.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="82jjlxpPR4U"
                    title="IN-5905 HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-5905 HD Objektivjustage"
              footer={
                <EuiText>
                  <p>Wir zeigen Ihnen in diesem Video wie Sie bei einer INSTAR IN-5905HD Überwachungskamera das Objektiv scharfstellen können. Jenachdem welchen Bereich man überwachen möchte, ist es ggf. nötig das Objektiv auf den gewünschten Bereich einzustellen.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>

        <EuiSpacer />
        
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="c136CT0SypU"
                    title="IN-5907 HD Objektivjustage"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="IN-5907 HD Objektivjustage"
              footer={
                <EuiText>
                  <p>Objektivjustage IN 5907HD.</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
